export default {
  // GENERAL
  'loading'             : "Loading...",
  'require_timeout'     : "Sorry, there was a load timeout. \n\nRefresh the page?",
  'date(s)'             : "Date |||| Dates",
  'page.jump_to_top'    : "Return to top",
  'page.scroll_for_more': "Scroll down for more",
  'welcome'             : "Welcome",
  'here'                : " here",

  // CHART
  'chart.click_to_load' : "Click to load graph",
  'chart.print'         : "Print chart",
  'chart.reset_zoom'    : "Reset zoom",

  // GENERAL INFORMATION
  'info.tip': "Tip",

  // DOWNLOAD
  'download.pdf': "Download PDF document",
  'download.jpg': "Download JPEG image",
  'download.png': "Download PNG image",
  'download.svg': "Download SVG vector image",

  // FILE
  'file.upload'       : "Upload",
  'file.drop_or_click': "Click here or drop file to upload",
  'file.max_upload_size': "File size must not exceed %{maxUploadFileSize} MB",

  // USER
  'user(s)'                     : "User |||| Users",
  'user.login'                  : "Login",
  'user.logout'                 : "Logout",
  'user.register'               : "Register",
  'user.invitations'            : "Invitations",
  'user.email'                  : "Email",
  'user.password'               : "Password",
  'user.mobile'                 : "Mobile",
  'user.mobile.hint'            : "Please include country code (+%{phoneCode} for %{countryName})",
  'user.title'                  : "Title",
  'user.title_with_example'     : "Title (e.g. Dr., Ms., Mr.)",
  'user.first_name'             : "First Name",
  'user.last_name'              : "Last Name",
  'user.middle_name'            : "Middle Name",
  'user.full_name'              : "%{firstName} %{lastName}",
  'user.full_name_and_title'    : "%{title} %{firstName} %{lastName}",
  'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
  'user.anonymous'              : "A User",
  'user.anonymous_admin'        : "Admin User",
  'user.dashboard'              : "Dashboard",
  'user.profile'                : "Profile",
  'user.profile.picture.upload' : "Upload profile picture",
  'user.profile.picture.change' : "Change",
  'user.profile.name'           : "NAME",
  'user.profile.address'        : "ADDRESS",
  'user.profile.mobile'         : "MOBILE",
  'user.profile.email_address'  : "EMAIL ADDRESS",
  'user.profile.language'       : "LANGUAGE",
  'user.profile.timezone'       : "TIMEZONE",
  'user.profile.no_mobile'      : "No mobile number on file",
  'user.profile.title_label'    : "Profile",
  'user.profile.title'          : "A completed profile will increase the available survey opportunities that are right for your medical expertise. Please ensure all profile details are correct and up to date." +
                                  "\n\nFields that contain important account information require contacting our internal team for review to ensure continued eligibility to receive surveys.",
  'user.profile.completion'     : "Profile Completion:",
  'user.profile.edit'           : "Edit",
  'user.profile.change_email'   : "Need to change your email?",
  'user.profile.pers_inf'       : "Personal Information",
  'user.profile.prof_inf'       : "Professional Information",
  'user.profile.add_inf'        : "Additional Information",
  'user.primary_lang'           : "Primary Language",
  'user.primary_lang?'          : "What is your primary language?",
  'user.country_of_res?'        : "What is your country of residence?",
  'user.survey_langs?'          : "What languages can you speak fluently?",
  'user.notify_email'           : "Notify by Email",
  'user.notify_mobile'          : "Notify by Mobile",
  'user.contact_support'        : "Contact Support",
  // SATURN-9
  'user.contact_trouble'        : "Having trouble? Contact us below:",
  'user.contact_email'          : "Send us an email",
  // end SATURN-9
  'user.contact_us'             : "<Contact Us>",
  'user.please_contact_us'      : "Please <contact us>.",
  'user.profession'             : "Profession",
  'user.profession?'            : "What is your profession?",
  'user.join_now'               : "Join Now",
  'user.welcome_back'           : "Welcome back!",
  'user.not_a_member?'          : "Not a Member Yet?",
  'user.forgot_password?'       : "Forgot your password?",
  'user.remembered_password'    : "I remembered my password",
  'user.reset_password'         : "Reset password",
  'user.reset_password.info'    : "Please enter a new password for your account in both password fields below and make sure they match. Remember, your email address is your login.",
  'user.accept_terms'           : "Accept Terms",
  'user.accept_terms.yes'       : "I accept the <terms and conditions>",
  'user.remember_me'            : "Remember me on this device",
  'user.time_zone'              : "Time Zone",
  'user.payment.policy'         : "Every time you reach %{currency}25 in rewards you will be notified and be able to select from our payment options via your InCrowd profile. Questions? Reach us via the chat window below.",
  'user.country.live_work?'     : "What country do you live and work in?",

  // USER LOGIN ERRORS
  'user.error.login.password_failure' : "Looks as though you've tried to log in unsuccessfully too many times. After %{triesLeft} more attempts, we'll lock your account for a short while as a security measure.",
  'user.error.login.locked'           : "Looks as though you've tried to log in unsuccessfully too many times. We've locked your account as a security measure, and it will unlock %{lockoutEnd}. Reset your password to unlock it now.",
  'user.error.login.requires_cookies' :  "You must allow the storage of cookies in order to use this website.",

  // USER ACCOUNT
  'user.account.settings'      : "Settings",
  'user.account.disable'       : "Disable my account",
  'user.account.disable_reason': "Reason",
  'user.account.disable_info'  : "If you would like to disable your account with InCrowd you may do so below. Please note that you will not be able to login after taking this action.",

  // USER VALIDATION
  'user.validation.error.skip_one': "You can only skip one question",

  // INCROWD
  'incrowd.about'    : "About",
  'incrowd.contact'  : "Contact",
  'incrowd.press'    : "Press",
  'incrowd.careers'  : "Careers",
  'incrowd.terms'    : "Terms",
  'incrowd.t_and_c'  : "Terms and Conditions",
  'incrowd.faq'      : "FAQ",
  'incrowd.privacy'  : "Privacy",
  'incrowd.copyright': "%{year} InCrowd Inc, All Rights Reserved",
  'incrowd.blog'     : "Blog",
  'incrowd.support'  : "Support",
  'incrowd.info.ios' : "Did you know that physicians in the InCrowd network can now send questions directly to their colleagues? Try it now using the <InCrowd iOS App>!",
  'incrowd.refer'    : "Like taking our surveys? <Refer a friend> today to join our crowd and you both earn 10 USD (or equivalent). Once your colleague answers answers a survey, they will receive a bonus!",

  // ROUTING
  'routing.page_not_found' : "Not Found",
  'routing.contact_support': "If you feel you've reached this page in error, please: %{contact_support}.",
  // SATURN-9
  'routing.contact_email'     : "%{contact_email}",
  // FORMS
  'form.button.back'          : "Back",
  'form.button.next'          : "Next",
  'form.button.cancel'        : "Cancel",
  'form.button.submit'        : "Submit",
  'form.button.save_changes'  : "Save Changes",
  'form.button.save_create'   : "Save & Create",
  'form.button.continue'      : "Continue",
  'form.button.close'         : "Close",
  'form.button.go!'           : "Go!",
  'form.button.complete!'     : "Complete now!",
  'form.button.update'        : "Update",
  'form.button.finish'        : "Finish",
  'form.button.search'        : "Search",
  'form.button.end'           : "End",
  'form.search.no_matches'    : "No matches found",
  'form.password_change'      : "Change Password",
  'form.password_current'     : "Current Password",
  'form.password_new'         : "New Password",
  'form.confirm_email'        : "Confirm Email",
  'form.confirm_password'     : "Confirm Password",
  'form.confirm_password_new' : "Confirm New Password",
  'form.required_fields'      : "Required fields",
  'form.nothing_selected'     : "Nothing selected",
  'form.confirm_field'        : "Confirm %{formFieldLabel}",
  'form.choice.n/a'           : "N/A",
  'form.choice.yes'           : "Yes",
  'form.choice.no'            : "No",
  'form.choice.blank_for_all' : "Leave blank to select all",
  'form.choices.select_all'   : "Select all",
  'form.choices.deselect_all' : "Deselect all",
  'form.field.private'        : "Private field",

  // FORM ERRORS
  // 'depEl' is a form field's label
  'form.error.generic_problem'       : "There was a problem processing your request",
  'form.error.time_slot_taken'       : "Unfortunately this time slot is no longer available. <Click here to refresh>",
  'form.error.required'              : "This field is required",
  'form.error.required_inline'       : "Required",
  'form.error.dep_required'          : "This field is required if \"%{depEl}\"'s value is %{expectedValue}",
  'form.error.dep_empty_required'    : "This field is required if \"%{depEl}\"'s value is empty",
  'form.error.dep_checked_required'  : "This field is required if \"%{depEl}\" is checked",
  'form.error.dep_unchecked_required': "This field is required if \"%{depEl}\" is unchecked",
  'form.error.i18n_mobile'           : "Please enter a valid number in the correct format (make sure the correct country code is selected)",
  'form.error.email'                 : "Please enter a valid email address",
  'form.error.integer'               : "Please enter a valid integer",
  'form.error.integer.string'        : "Please use only numbers",
  'form.error.integer.leading_zeros' : "Please use only numbers (no leading zeros)",
  'form.error.password'              : "Please enter a valid password. It must be between 7 and 32 characters and contain at least one digit.",
  'form.error.equal_to'              : "Please enter the same value again",
  'form.error.dep_equal_to'          : "This field must match the \"%{depEl}\" field",
  'form.error.minlength'             : "Please enter at least %{count} character |||| Please enter at least %{count} characters",
  'form.error.maxlength'             : "Please enter no more than %{count} character |||| Please enter no more than %{count} characters",
  'form.error.decimal'               : "Please enter a valid number",
  'form.error.minimum'               : "Please enter a value greater than or equal to %{min}",
  'form.error.maximum'               : "Please enter a value less than or equal to %{max}",
  'form.error.rank_all'              : "Please submit a response for every option.",
  'form.error.rank_unique'           : "Please use each rank only once",
  'form.error.must_add_to'           : "Values add up to %{actualValue}. They must add up to %{requiredValue}",
  'form.error.must_add_to_min'       : "Values add up to %{actualValue}. They must add up to at least %{requiredValue}",
  'form.error.must_add_to_max'       : "Values add up to %{actualValue}. They must add up to no more than %{requiredValue}",
  'form.error.must_add_to_min_max'   : "Values add up to %{actualValue}. They must add up to between %{requiredValue}",
  'form.error.row_must_add_to'       : "Responses for row %{axisName} must add up to %{requiredValue}",
  'form.error.column_must_add_to'    : "Responses for column %{axisName} must add up to %{requiredValue}",
  'form.error.system'                : "An application error has occurred.",

  // FORM SUCCESSES
  'form.success.updated': "Successfully updated",

  // GENERIC DATA
  'data.updating'      : "Updating",
  'data.updated_ago'   : "Updated %{timeAgo}",
  'data.update_now'    : "Update now",
  'data.average'       : "Average",
  'data.median'        : "Median",
  'data.mode'          : "Mode",
  'data.sum'           : "Sum",
  'data.required_total': "Required Total",
  'data.standard_dev'  : "Standard Deviation",
  'data.num_of_total'  : "%{num} of %{total}",
  'data.range'         : "%{min} to %{max}",
  'data.num_minimum'   : "%{num} (minimum)",
  'data.num_maximum'   : "%{num} (maximum)",
  'data.minimum'       : "minimum",
  'data.maximum'       : "maximum",
  'data.quartile.low'  : "Lower quartile",
  'data.quartile.high' : "Upper quartile",
  'data.percentage'    : "%{num}%",
  'data.rating.scale'  : "Rating scale",
  'data.rating.value'  : "Rating <%{num}>",
  'data.ranking.value' : "Ranking <%{num}>",
  'data.ranking.first' : "% Ranked first",

  // NUMERABLE DATA
  'numerable.allocated': "Allocated",
  'numerable.used'     : "Used",
  'numerable.remaining': "Remaining",

  // USER ERRORS
  'user.error.dup_email'               : "Another user already registered with the given email address. <Log in instead?>",
  'user.error.dup_sms'                 : "Another user already registered with the given mobile number",
  'user.error.dne_email'               : "We can't find a user with that email address",
  'user.error.invalid_login'           : "We didn't recognize your email or password.",
  'user.error.invalid_password'        : "Incorrect password",
  'user.error.invalid_current_password': "Incorrect current password",
  'user.error.insufficient_permissions': "Uh oh, you don't have sufficient permissions to be here!",
  'user.error.no_accept_terms'         : "You haven't accepted our terms and conditions. Please do so ",
  'user.error.session_expired'         : "Session expired. Please log in.",
  'user.error.please_log_in'           : "Please log in",
  'user.error.paypal_restricted'       : "We cannot pay your PayPal account due to PayPal not recognizing your payment email provided. Please login to PayPal to verify your account and try payment again.",
  'user.error.account_disabled'        : "Your account has been disabled. If you would like to enable your account, please <contact us>.",
  'user.error.password_reset_expired'  : "Oops, you took too long! Please <click here to try again>.",
  'user.error.password_reset_unauth'   : "Oops, either you already used this link to reset your password or it has expired. Please <go to the login page> to try again.",
  'user.error.reschedule_link_expired' : "You are attempting to cancel or reschedule an interview within 24 hours of its scheduled completion time, please contact qualinterviews@incrowdnow.com for assistance with this request.",

  // USER SUCCESSES
  'user.success.password_reset_sent': "You will receive an email shortly with a link to reset your password.",
  'user.success.logged_out'         : "You've successfully logged out",
  'user.success.accepted_terms'     : "Thank you for accepting the terms.",
  'user.success.account_disabled'   : "Your account has been disabled",

  // 404
  // SATURN-9
  '404.title'    : "404",
  '404.subtitle' : "looks like this page doesn’t exist.",
  // end SATURN-9
  '404.what_next': "Where would you like to go instead?",

  // UNSUPPORTED BROWSER OR SETTINGS
  'unsupported.browser'      : "Hey! It looks like you're using a browser that won't work with InCrowd Answers",
  'supported.browsers'       : "Here are some browsers we know work well",
  'supported.browser.firefox': "Firefox",
  'supported.browser.chrome' : "Chrome",
  'supported.browser.safari' : "Safari",
  'supported.browser.ie'     : "Internet Explorer Version 11+",

  // LIST
  'list.view_all'  : "View All",
  'list.none_found': "No results found",
  'list.showing'   : "Showing <%{min}> to <%{max}> of <%{total}>",
  'list.page.first': "First Page",
  'list.page.last' : "Last Page",
  'list.page.next' : "Next",
  'list.page.prev' : "Previous",

  // PROJECT
  'project(s)': "Project |||| Projects",

  // SURVEY
  'survey(s)'                : "Survey |||| Surveys",
  'peer_survey(s)'           : "Peer Survey |||| Peer Surveys",
  'survey_list.none_found'   : "No surveys found",
  'survey.error.no_questions': "There are no questions in this survey",
  'survey.error.no_data': "There is no data available for this survey at this time",
  

  // TRACKER / PULSES
  'pulse.wave(s)' : "Wave |||| Waves",
  'pulse.wave.num': "Wave %{num}",

  // QUESTION
  'question(s)'                       : "Question |||| Questions",
  'question.comments'                 : "Comments",
  'question.comments_required'        : "Comments (required)",
  'question.comments_optional'        : "Comments (optional)",
  'question.text_placeholder'         : "Answer here...",
  'question.dropdown_placeholder'     : "Select the appropriate option",
  'question.numeric_input_placeholder': "Enter Number",
  'numerical_matrix.placeholder'      : "Number",
  'question.time_slots.none'          : "None of the times listed above are convenient for me. I will specify my availability below.",
  'question.time_slots.none_cancel'   : "None of these times are convenient. Please cancel my interview.",
  'question.time_slots.cancel'        : "Please cancel my interview",

  // QUESTION ROWS AND COLUMNS
  'question.choice(s)': "Choice |||| Choices",
  'question.row(s)'   : "Row |||| Rows",
  'question.col(s)'   : "Column |||| Columns",

  // QUESTION RESULTS ANSWERING INFO
  'question.results_info.select'                  : "Each person selected one choice.",
  'question.results_info.multiselect'             : "Each person selected at least one choice.",
  'question.results_info.multi_min'               : "Each person selected at least %{count} choice. |||| Each person selected at least %{count} choices.",
  'question.results_info.multi_max'               : "Each person selected at most %{count} choice. |||| Each person selected at most %{count} choices.",
  'question.results_info.multi_range'             : "Each person selected between %{min} and %{max} choices.",
  'question.results_info.multi_exact'             : "Each person selected exactly %{count} choice. |||| Each person selected exactly %{count} choices.",
  'question.results_info.numeric_range'           : "All values are between %{min} and %{max}.",
  'question.results_info.numeric_range.screen_in' : "%{num} of %{smart_count} person screened in. |||| %{num} of %{smart_count} people screened in.",
  'question.results_info.rating'                  : "Ratings range from %{min} (%{minLabel}) to %{max} (%{maxLabel}).",
  'question.results_info.forced_rating'           : "Rankings range from %{min} (%{minLabel}) to %{max} (%{maxLabel}). Each person used each rank only once.",
  'question.results_info.numeric_dist'            : "Enter values that add up to %{max}.",
  'question.results_info.max_piped_from'          : "Maximum piped from %{questionTitle} (\"%{questionChoice}\")",
  'question.results_info.matrix_single'           : "Each person selected one choice per question.",
  'question.results_info.matrix_multiple'         : "Each person selected at least one choice per question.",

  // QUESTION RESULTS
  'question_results.qual.scheduled_times': "Booked interview times",
  'question_results.other_choices'       : "All other choices",

  // QUESTION HINTS
  'question.hint.multi_min'    : "Please select at least %{min} of the following choices.",
  'question.hint.multi_max'    : "Please select at most %{max} of the following choices.",
  'question.hint.multi_range'  : "Please select between %{min} and %{max} of the following choices.",
  'question.hint.multi_exact'  : "Please select exactly %{num} of the following choices.",
  'question.hint.matrix_min'   : "Please select at least %{min} choices for each of the following categories.",
  'question.hint.matrix_max'   : "Please select at most %{max} choices for each of the following categories.",
  'question.hint.matrix_range' : "Please select between %{min} and %{max} choices for each of the following categories.",
  'question.hint.matrix_exact' : "Please select exactly %{num} choices for each of the following categories.",
  'question.hint.numeric_range': "Please enter a value between %{min} and %{max} in each field.",
  'question.hint.numeric_min'  : "Please enter a value greater than or equal to %{min} in each field.",
  'question.hint.numeric_max'  : "Please enter a value less than or equal to %{max} in each field.",
  'question.hint.forced_rating': "Please order the choices by dragging and dropping them. When you're happy with the ranking, press submit.",
  'question.hint.numeric_dist' : "Please enter values that add up to %{max}.",
  'question.hint.scheduler'    : "All times are in %{timeZone}.",

  // QUESTION ATTACHMENTS
  'question.attachment_list.required': "You must view all content before continuing. Use the arrows %{arrowIcons} to scroll through.",

  // QUESTION ERROR
  'question.error.ranking.unranked': "You haven't changed the order of the choices. Are you sure you want to submit the original order?",

  // ANSWERS
  'answer(s).count'               : "%{count} answer |||| %{count} answers",
  'answer.person(s).count'        : "%{count} person answered this question. |||| %{count} people answered this question.",
  'answer.person(s).count_numeric': "%{count} person answered <%{num}> |||| %{count} people answered <%{num}>",

  // USER ANSWERS
  'user.answer.number': "You answered %{number}",
  'user.answer.text'  : "You answered %{text}",
  'user.answer.label' : "You answered:",
  'user.answer.chosen': "You chose this",

  // PEOPLE
  'person(s).count'       : "%{count} person |||| %{count} people",
  'person(s).num_of_total': "%{num} of %{count} person |||| %{num} of %{count} people",

  // LANGUAGE
  'language(s)': "Language |||| Languages",

  // ADDRESS
  'user.address'      : "Address",
  'address.line1'     : "Address Line 1",
  'address.line2'     : "Address Line 2",
  'address.home.line1': "Home Address Line 1",
  'address.home.line2': "Home Address Line 2",
  'address.city'      : "City",
  'address.state'     : "State / Province / Region",
  'address.zipcode'   : "Zip Code",
  'address.country'   : "Country",

  // PAYMENTS
  'payment(s)'    : "Payment |||| Payments",
  'payment.format': "%{currency}%{amount}",

  // CONTACT TOKEN
  'contact_token.valid'            : "Successfully validated new contact information.",
  'contact_token.invalid'          : "Sorry, validation was unsuccessful.",
  'contact_token.already_validated': "Contact information has already been validated.",

  // CONTACT ADDRESS
  'contact_address.unsubscribe'              : "Unsubscribe",
  'contact_address.unsubscribe.are_you_sure?': "Are you sure you want to unsubscribe from all communications sent to <%{address}>?",
  'contact_address.validate'                 : "We can't send survey invitations to <%{address}> until you <validate this contact method>.",
  'contact_address.email_sent'               : "Validation email successfully sent. Please check your email and follow the instructions.",
  'contact_address.sms_sent'                 : "Validation sms successfully sent. Please check your texts and follow the instructions.",

  // ACTIVITY
  'activity_list.show_more'                : "Show more",
  'activity_list.none_found'               : "No recent activity",
  'activity_list.no_more'                  : "No more activity to report",
  'activity.user_login'                    : "<%{user}> logged in",
  'activity.user_impersonation'            : "<%{impersonator}> logged in as <%{targetUser}>",
  'activity.user_survey_completion'        : "<%{user}> completed survey <%{survey}>",
  'activity.user_survey_screenout'         : "<%{user}> screened out of <%{survey}>",
  'activity.user_survey_preview_completion': "<%{user}> completed a preview of survey <%{survey}>",
  'activity.user_survey_preview_screenout' : "<%{user}> screened out of a preview of <%{survey}>",
  'activity.user_question_completion'      : "<%{user}> answered <%{question}> for <%{survey}>",
  'activity.contract_creation'             : "Contract <%{contract}> was created",
  'activity.contract_edit'                 : "Contract <%{contract}> was modified",
  'activity.survey_closing'                : "Survey <%{survey}> has closed",
  'activity.survey_publishing'             : "Survey <%{survey}> was published by <%{user}>",
  'activity.survey_republishing'           : "Survey <%{survey}> was republished by <%{user}>",
  'activity.survey_invite(s)_dispatch'     : "<%{count}> invite was sent for <%{survey}> |||| <%{count}> invites were sent for <%{survey}>",
  'activity.survey_reminder(s)_dispatch'   : "<%{count}> reminder was sent for <%{survey}> |||| <%{count}> reminders were sent for <%{survey}>",
  'activity.survey_closed_manually'        : "Survey <%{survey}> was closed by <%{user}>",
  'activity.created_survey'                : "Survey <%{survey}> was created by <%{user}>",
  'activity.crowd_attributes_changed'      : "Crowd filters updated for <%{crowd}>",
  'activity.crowd_member(s)_added'         : "<%{count}> member was added to <%{crowd}> |||| <%{count}> members were added to <%{crowd}>",
  'activity.crowd_member(s)_removed'       : "<%{count}> member was removed from <%{crowd}> |||| <%{count}> members were removed from <%{crowd}>"
}
